<template>
  <div id="home"  v-bind:class="{
        classPopup: showPopup
      }"  @click="hideListGenres">
    <HomeNav />
    <section class="detail-block">
      <div class="container">
        <div class="row d-flex">
          <div class="mr-auto">
            <h3 class="font-semibold float-left">Movies</h3>
            <div class="movie-btn float-left ml-3">
              <button
                type="button"
                class="btn btn-outline-dark"
                @click.stop="showListGenres($event)"
              >
                {{genresLabel}} <i class="fa fa-caret-down ml-2"></i>
              </button>
              <ul
                class="movie-list flex-wrap justify-content-center"
                v-if="showGenres"
              >
               
                <li v-for="(item, index) in menuItems" :key="index">
                  <a @click="updateParent(item)">{{ getName(item)}}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="ml-auto suggestion-dropdown">
            <div class="dropdown">
              <button
                class="btn btn-filter"
                type="button"
                id="dropdownMenu2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  src="../../assets/img/dash-icon.png"
                  width="18"
                  class="mr-2"
                />
                SUGGESTIONS FOR YOU <i class="fa fa-caret-down ml-2"></i>
              </button>
              <div
                class="dropdown-menu filter-menu dropdown-menu-right"
                aria-labelledby="dropdownMenu2"
              >
                <button class="dropdown-item" type="button" @click="sortOne">
                  A - Z
                </button>
                <button class="dropdown-item" type="button" @click="sortTwo">
                  Z - A
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid mt-5">
        <div class="d-flex flex-wrap justify-content-center">
          <div class="col-desktop" v-for="(item, index) in items" :key="index">
            <div class="series-block withhover" @click="goToPlayer(item)">
              <img class="img-fluid" :src="item.thumbnail.large" alt="" />
              <div class="more-cnt text-center">
                <h5 class="pt-3">{{ getName(item) }}</h5>
                <p class="py-2" >Duration {{ getRunningTime(item)}}</p>
                <p>PG13</p>
                <p class="py-3">{{ getDescription(item) | trim }}</p>
                <div class="d-flex justify-content-between">
                  <a class="border circle-Sm" @click="voteVideo(item, true)">
                    <img class="like" src="../../assets/img/like.svg" alt="" />
                  </a>
                  <a class="border circle-Sm" @click="voteVideo(item, false)">
                    <img
                      class="unlike"
                      src="../../assets/img/unlike.svg"
                      alt=""
                    />
                  </a>
                  <a class="border circle-Sm" @click="toggleFavorited(item)">
                    <img
                      src="../../assets/img/minis-icon.svg"
                      v-if="my_favourite(item)"
                      alt=""
                      class="plus-icon"
                    />
                    <img class="plus-icon" src="../../assets/img/plus.svg" v-else />
                  </a>
                </div>
                <div class="py-3 d-flex justify-content-center">
                  <a @click="playvideo(item)" class="d-inline-block">
                    <img src="../../assets/img/play.svg" class="play" alt="" />
                  </a>
                </div>
                <div class="pt-2 d-flex justify-content-center">
                  <a
                    @click="goToDetails(item)"
                    class="d-inline-block btn btn-outline-light"
                  >
                    More
                    <i class="fa fa-angle-right ml-2" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showNoGerne">
          <h1>There is no movies for {{ this.getCurrentGerneName }}</h1>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";
import Helpers from "../../Mixins/Helpers.js";
export default {
  name: "ListMovies",
  components: {
    HomeNav,
  },
  mixins: [Helpers],
  metaInfo: {
		title: "MOVIES",
		meta: [
			{
				name: "description",
				content:
					"Watch and download the latest array of premium Nollywood blockbuster movies and Tv Series on iBAKATV. Enjoy amazing discounts on subscriptions.",
			},
		],
	},
  watch: {
    parent: function(val) {
      if (val != null) {
        this.getParent(val);
      }
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
  filters: {
    trim: function(value) {
      if (value.length > 100) {
        return value.substring(0, 100) + "...";
      } else {
        return value;
      }
    },
  },
  data() {
    return {
      items: [],
      parent: null,
      menuItems: null,
      showGenres: false,
      showUpdatePopUp: false,
      nocontent: false,
      currentGerne: null,
      showNoGerne: false,
      movie_gernes: "",
	  duidVal: null,
    genresLabel:"Genres"
    };
  },
  methods: {
    goToDetails(current) {
      var dynamicRoute = "";
      if (current.type == "vod") {
        dynamicRoute = "/details/" + current.id + "/" + this.parent;
      } else if (current.type == "Season") {
        dynamicRoute = "/playlistdetails/" + current.id;
      }

      this.$router.push("" + dynamicRoute);
    },
    goToPlayer(video) {
      if (this.isPlatformMobile() == true || this.isPlatformTablet() == true) {
        this.goToDetails(video);
      }
    },
    playvideo(current) {
      this.checkSubs(current);
    },

    checkSubs(current) {
      this.$store
        .dispatch("getVideoPlaybackURLV2", {
          videoId: current.id,
          deviceId: this.duidVal,
        })
        .then((res) => {
          if (current.type == "Series") {
            var currentCat = current.id;
            this.$store.dispatch("getCatalougeById", currentCat).then((res) => {
              var currentSeason = res._embedded.items[0].id;
              this.$store
                .dispatch("getCatalougeById", currentSeason)
                .then((res) => {
                  var currentSeasonVideoId = res._embedded.items[0].id;
                  var dynamicRoute = "/viewvideo/" + currentSeasonVideoId;
                  this.$router.push("" + dynamicRoute);
                });
            });
          } else {
            var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          }
        })
        .catch((err) => {
          if (err.response.data.error.status == "422") {
            // show upgrade screen popup
          }
          if (err.response.data.error.status == "403") {
            this.$store.commit("showPopup", true);
            this.$store.commit("showdefaultFooter", false)
            window.scrollTo(0, 0);
          }
          if (err.response.data.error.status == "404 ") {
            //this.$store.commit("setNotification", "Please try again later ");
            this.$store.commit("showPopup", true);
            window.scrollTo(0, 0);
          }
          this.$store.commit("setLoader", false);
        });
    },
    voteVideo(show, status) {
      this.$store
        .dispatch("voteVideo", {
          id: show.id,
          status: status,
        })
        .then(() => {});
    },
    my_favourite(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    toggleFavorited(show) {
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => {
            // this.$store.commit("refreshMyList" ,true)
          });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            //this.$store.commit("refreshMyList" ,true)
          });
      }
    },
    sortOne() {
      if(this.items && this.items.length>0){
      this.items.sort(function(a, b) {
        var titleA = a.name.toLowerCase(),
          titleB = b.name.toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
      });
      }
    },
    sortTwo() {
       if(this.items && this.items.length>0){
      this.items.sort(function(a, b) {
        var titleA = a.name.toLowerCase(),
          titleB = b.name.toLowerCase();
        if (titleA > titleB) return -1;
        if (titleA < titleB) return 1;
        return 0;
      });
       }
    },
    showListGenres(ev) {
      ev.preventDefault();
      this.showGenres = true;
    },
    hideListGenres() {
      this.showGenres = false;
    },
    hideUpdatephone() {
      this.showUpdatePopUp = false;
    },
    getParent(id) {
      var self = this;
      self.showNoGerne = false;
      this.$store
        .dispatch("getCatalougeById", id)
        .then((res) => {
          self.items = res._embedded.items;
          if (self.items.length == 0) {
            self.showNoGerne = true;
          }
          this.$store.commit("setLoader", false);
          this.showUpdatePopUp = true;
        })
        .catch((err) => {
          //this.nocontent = true
          self.showNoGerne = true;
          this.$store.commit("setLoader", false);
        });
    },
    showAll() {
      this.parent = this.$store.getters.getGlobalConfigs.list_movie;
       this.genresLabel="All"
    },
    updateParent(gerne) {
      this.parent = gerne.id;
      this.currentGerne = gerne;
      this.genresLabel=gerne.name;
    },
    getGernes(id) {
      this.$store
        .dispatch("getCatalougeById", id)
        .then((res) => {
          this.menuItems = res._embedded.items;
          this.$store.commit("setLoader", false);
          this.showUpdatePopUp = true;
          this.updateParent(this.menuItems[0])
        })
        .catch((err) => {
          //this.nocontent = true
          this.$store.commit("setLoader", false);
        });
    },
    getName(item){
      if (item.name) {
        return item.name;
      }
      return "";
    },
    getRunningTime(item) {
      if (item.metaData.running_time) {
        return item.metaData.running_time;
      }
      return "";
    },
    getDescription(item) {
      if (item.description) {
        return item.description;
      }
      return "";
    },
    getCurrentGerneName(){
    if (this.currentGerne && this.currentGerne.length >0 && this.currentGerne.name) {
        return this.currentGerne.name;
      }
      return "";
    }
    
  },
  computed: {
    isFavorited(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    showfav() {
      if (this.$store.state.user.mylist.length > 0) {
        return true;
      } else {
        return false;
      }
    },
     	showPopup(){
			return this.$store.state.showPopup;
		},
    
    
  },
  created() {
    self = this;
    this.homeCategory = JSON.parse(
      this.$store.state.globalconfigs.home_category
    );
    this.$store.commit("showPopup", false);
    this.parent = this.$store.state.globalconfigs.list_movie;
    this.movie_gernes = this.$store.getters.getGlobalConfigs.movie_gernes;
    this.$store.commit("showdefaultnav", false);
    this.$store.commit("showdefaultFooter", true);
    this.$store.commit("setLoader", true);
    if (this.$store.state.user.logedin == false) {
      this.$store.commit("setLoader", false);
      this.$router.push("/login");
      return false;
    }
    this.getGernes(this.parent);

    setTimeout(function() {
      self.showUpdatePopUp = false;
    }, 9000);
  },
};
</script>

<style scoped>
a,
button {
  cursor: pointer;
}
.home-card {
  padding-top: 70px;
  position: relative;
  margin: 0 auto;
  max-width: 80%;
  width: 80%;
}
.no-content {
  text-align: center;
  padding: 50px;
  color: #fff;
}
.owl-nav .disabled {
  display: none;
}

.cp {
  cursor: pointer !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.classPopup{
  position:fixed;
}
</style>
